/* eslint-disable*/
import { ReactElement, useState } from 'react';
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  SortingState
  // getPaginationRowModel
} from '@tanstack/react-table';
import { ActionData, UserDetails } from '../constants/telosair-interfaces';
import { UserTableColumns } from './UserTableColumns';

type UsersTableProps = {
  users: (UserDetails & { action: (action: ActionData<UserDetails>) => void })[];
};

/**
 * UsersTable component.
 * @param props - Properties of UsersTable component.
 * @returns - Recat element for UsersTable.
 */
export default function UsersTable(props: UsersTableProps): ReactElement {
  const { users } = props;
  const [sorting, setSorting] = useState<SortingState>([{ id: 'id', desc: true }]);
  const [paginationvisble, setPaginationVisible] = useState(false);

  const table = useReactTable({
    columns: UserTableColumns,
    data: users,
    state: {
      sorting
    },
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting
  });

  return (
    <>
      <div className="bg-white my-3 dark:bg-container-700 flex text-gray-400 dark:text-gray-400 text-sm font-medium border-b border-b-gray-300 dark:border-b-gray-900 border-t border-t-gray-300 dark:border-t-gray-900">
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr
                className="w-full text-center text-gray-400 text-xs font-medium"
                key={headerGroup.id}
              >
                {headerGroup.headers.map((header) => (
                  <th key={header.id} className="px-6 py-3 items-center">
                    {!header.isPlaceholder && (
                      <div
                        {...{
                          className: header.column.getCanSort()
                            ? 'cursor-pointer select-none flex min-w-[36px]'
                            : '',
                          onClick: header.column.getToggleSortingHandler()
                        }}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {{
                          asc: <span className="pl-2">↑</span>,
                          desc: <span className="pl-2">↓</span>
                        }[header.column.getIsSorted() as string] ?? null}
                      </div>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr
                className="bg-white dark:bg-container-500 text-gray-500 font-medium dark:text-gray-300 border-b border-b-gray-300 dark:border-b-gray-900"
                key={row.id}
              >
                {row.getVisibleCells().map((cell) => (
                  <td className="px-4 py-2" key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Pagniation Disabled */}
      {paginationvisble && (
        <div className="flex sm:flex-row flex-col w-full py-2 items-center gap-1 text-500">
          <div className="sm:mr-auto sm:mb-0 mb-2 text-500">
            <span className="mr-2 text-gray-500">Number of rows</span>
            <select
              className="border p-1 rounded w-16 border-gray-200"
              value={table.getState().pagination.pageSize}
              onChange={(e) => {
                table.setPageSize(Number(e.target.value));
              }}
            >
              {[8, 10, 12].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </select>
          </div>
          <div className="flex gap-2">
            <button
              className={`${
                !table.getCanPreviousPage()
                  ? 'bg-gray-100'
                  : 'hover:bg-gray-200 hover:curstor-pointer bg-gray-100'
              } rounded p-1`}
              onClick={() => table.setPageIndex(0)}
              disabled={!table.getCanPreviousPage()}
            >
              <span className="w-5 h-5">{'<<'}</span>
            </button>
            <button
              className={`${
                !table.getCanPreviousPage()
                  ? 'bg-gray-100'
                  : 'hover:bg-gray-200 hover:curstor-pointer bg-gray-100'
              } rounded p-1`}
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
            >
              <span className="w-5 h-5">{'<'}</span>
            </button>
            <span className="flex items-center gap-1">
              <input
                min={1}
                max={table.getPageCount()}
                type="number"
                value={table.getState().pagination.pageIndex + 1}
                className="border p-1 rounded item-center w-10"
              />
              Pages {table.getPageCount()}
            </span>
            <button
              className={`${
                !table.getCanNextPage()
                  ? 'bg-gray-100'
                  : 'hover:bg-gray-200 hover:curstor-pointer bg-gray-100'
              } rounded p-1`}
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
            >
              <span className="w-5 h-5">{'>'}</span>
            </button>
            <button
              className={`${
                !table.getCanNextPage()
                  ? 'bg-gray-100'
                  : 'hover:bg-gray-200 hover:curstor-pointer bg-gray-100'
              } rounded p-1`}
              onClick={() => table.setPageIndex(table.getPageCount() - 1)}
              disabled={!table.getCanNextPage()}
            >
              <span className="w-5 h-5">{'>>'}</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
}
/*eslint-disable*/
